import { useTranslation } from 'react-i18next'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { JOURNEY_COPY } from '../fidelityJourney'
import HelpPanel from '../HelpPanel/HelpPanel'
import HelpScreenshot from '../HelpScreenshot/HelpScreenshot'
import { StyledKicker, StyledScreenshotGrid, StyledVerifyColumn, StyledVerifyText } from '../styled-components'

const HELP = `${JOURNEY_COPY}.help`

interface VerifyDetailsHelpProps {
  kicker: string
  src: string
  alt: string
}

const VerifyDetailsHelp = ({ kicker, src, alt }: VerifyDetailsHelpProps) => {
  const { t } = useTranslation()

  return (
    <HelpPanel title={t(`${HELP}.journey_title`)}>
      <StyledKicker>{kicker}</StyledKicker>
      <StyledScreenshotGrid>
        <HelpScreenshot src={src} alt={alt} />
        <StyledVerifyColumn>
          <StyledVerifyText>{t(`${HELP}.journey_text`)}</StyledVerifyText>
          <SDNotification type='warning' primaryText={t(`${HELP}.moving_in`)} />
          <SDNotification type='info' iconType='default' primaryText={t(`${HELP}.meter_owned`)} />
        </StyledVerifyColumn>
      </StyledScreenshotGrid>
    </HelpPanel>
  )
}

export default VerifyDetailsHelp
